import React, {Component} from "react"
import {withRouter} from "react-router-dom";
import axios from "axios";
import {setAuth} from "../../services/authService";
import {toast, ToastContainer} from "react-toastify";

class ForgetPassword extends Component {


    state = {
        error: "",
        email: ""
    };

    validate = () => {
        const {email} = this.state

        let error = ''

        if (!email) {
            error = "Email is required!"
        } else if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}$/.test(email)) {
            error = "Invalid Email!"
        }

        this.setState({
            error
        })

        if (error) {
            throw Error(error)
        }


    }


    handleSubmit = e => {
        e.preventDefault()
        const {email} = this.state

        try {
            this.validate()

            const data = {
                email,
            };

            axios.post('user/password_reset/', data)
                .then(res => {
                        setAuth(res.data.data)
                        toast.success("Email successfully sent");
                        this.setState({
                            email: ''
                        })
                        // window.location.href = '/'
                        // this.email.value= "";
                    }
                ).catch(err => {
                    toast.error("This email not registered!");
            })


        } catch (e) {

        }


    }

    handleChange = e => {
        const email = e.target.value
        this.setState({
            email
        }, () => {
            try {
                this.validate()
            } catch (e) {

            }
        })


    }

    render() {

        return (
            <>

                <form onSubmit={this.handleSubmit}>
                    <ToastContainer/>
                    <div className="c-pass forget_pass">
                        <h1 className="c-pass--title text-jost-sb-50-wt">Change Password</h1>
                        <div className="c-pass__wrap">
                            <div className="c-pass__box">
                                <h2 className="c-pass__box--txt text-jost-sb-22">Enter your registered E-mail address to
                                    obtain a new password.</h2>
                                <div className="c-pass__box__form">
                                    <div>
                                        <input className="form__input-md"
                                               type="text" placeholder="EMAIL"
                                               name="email"
                                               onChange={this.handleChange}
                                               value={this.state.email}
                                        />
                                        {
                                            !!this.state.error &&
                                            <span style={{color: 'red'}}>{this.state.error}</span>
                                        }


                                    </div>
                                    <button target="_self" className="res-btn-primary">Reset Password</button>

                                </div>
                                <div className="c-pass__box--links">


                                </div>


                            </div>
                        </div>
                    </div>
                </form>

            </>

        )
    }
}

export default withRouter(ForgetPassword);